import api from '@/api';

const state = {
  // 用户信息
  user_name: '',
  user_id: '',
  tel_num: '',
  login_id: '',
  // 通話履歴で使用するユーザー・顧客リスト
  userList: [],
  customerList: [],
}

const getters = {
  // 通話履歴のBuddiesListで利用するgetter
  // 内線ユーザーと外線顧客を統合して返す
  allUsersAndCustomers(state) {
    let arr = [];
    // 内線ユーザー（getPbxUserStatusのレスポンス形式）
    state.userList.forEach(user => arr.push({
      id: user.sipNum || user.tel_num || '',
      phone: user.sipNum || user.tel_num || '',
      name: (user.lastname || '') + (user.firstname || ''),
      firstname: user.firstname || '',
      lastname: user.lastname || '',
      logo: user.logo || user.logo_url || '',
    }));
    // 外線顧客（getCustomerInfoByPageのレスポンス形式）
    state.customerList.forEach(customer => arr.push({
      id: customer.customer_id || customer.phonenum || '',
      phone: customer.phonenum || customer.telNum || '',
      name: (customer.lastname || customer.lastName || '') + (customer.firstname || customer.firstName || ''),
      firstname: customer.firstname || customer.firstName || '',
      lastname: customer.lastname || customer.lastName || '',
      logo: customer.logo_url || customer.logoUrl || '',
    }));
    return arr;
  }
}

const actions = {
  // 获取个人配置
  getUserInfo(context) {
    api.getUserInfo().then((res) => {
				if (res && res.data && res.data.user) {
					const user = res.data.user;
					if (user.tel_num) {
						context.commit('changeUserTelNum', user.tel_num);
					}
					if (user.name) {
						sessionStorage.setItem('user_name', user.name);
            context.commit('changeUserName',user.name);
					}
				}
			}).catch((err) => {
				console.error('Failed to get user info:', err);
			});
  },

  // 内線ユーザーリストを取得（通話履歴の名前表示用）
  fetchUserList(context) {
    api.getPbxUserStatus().then((res) => {
      if (res.data.result && res.data.result.length) {
        context.commit('changeUserList', res.data.result);
      }
    }).catch((err) => {
      console.error('Failed to fetch user list:', err);
    });
  },

  // 外線顧客リストを取得（通話履歴の名前表示用）
  fetchCustomerList(context) {
    let params = {
      page: 1,
      pageSize: 9999
    };
    api.getCustomerInfoByPage(params).then((res) => {
      if (res.data != 'fail' && res.data.data && res.data.data.list) {
        context.commit('changeCustomerList', res.data.data.list);
      }
    }).catch((err) => {
      console.error('Failed to fetch customer list:', err);
    });
  },

  // 初始化
  init(context) {
    context.dispatch('getUserInfo');
    context.dispatch('fetchUserList');
    context.dispatch('fetchCustomerList');
  },
}

const mutations = {
  changeUserName(state, user_name) {
    state.user_name = user_name;
  },

  changeUserId(state, userId) {
    state.user_id = userId;
  },

  changeUserTelNum(state, tel_num) {
    state.tel_num = tel_num;
  },

  changeLoginId(state, login_id) {
    state.login_id = login_id;
  },

  changeUserList(state, userList) {
    state.userList = userList;
  },

  changeCustomerList(state, customerList) {
    state.customerList = customerList;
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
